import React from 'react'
import ResetPasswordSteps from './ResetPasswordSteps/ResetPasswordSteps'

const ResetPassword = () => {
  return <ResetPasswordSteps />
}

export default ResetPassword
